<template>
    <div class="change-password-body">
        <div class="change-password-header">
            <div class="autodesk-logo-header">
                <img class="autodesk-logo" src="../assets/images/aone_logo.svg" @click="navigateToHome()" />
            </div>
        </div>
        <div class="notification-banner">
            <span class="offset-md-1" v-html="CONSTANTS.NOTIFICATION_BANNER_TEXT" />
        </div>
        <reset-password-body />
        <password-management-footer />
    </div>

</template>

<script>
    import ResetPasswordBody from '@/components/ResetPasswordBody.vue'
    import PasswordManagementFooter from "./PasswordManagementFooter"
    import MixpanelMixin from "@/mixins/MixpanelMixin";

    export default {
        name: 'reset-password',
        mixins: [MixpanelMixin],
        components: {
            PasswordManagementFooter,
            ResetPasswordBody
        },
        mounted() {
            this.trackEvent("Page Hit: Employee Hub Reset Password");
        },
        methods: {
            navigateToHome() {
                location.href = process.env.VUE_APP_LANDING_PAGE_API;
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .autodesk-logo-header{
        height: min-content;
        margin-bottom: 0;
        border-radius: 0;
        min-height: 60px;
        padding-right: 28px;
        padding-left: 28px;
        
        border: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .change-password-body {
        min-width: 315px;
    }
    .change-password-header {
        background-color: #000000;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    .notification-banner {
        padding: 20px;
        background-color: var(--tag-color);
    }
    .notification-banner span {
        font-weight: 600;
        line-height: normal;
    }
    .notification-banner /deep/ b {
        font-family: artifaktElementBold;
    }
</style>
